/**
 * @fileoverview Agent definition for run-refine-full-v2.
 *
 * This is a COMPOSITE agent that orchestrates a two-step pipeline:
 * 1. refine-synthesizer: Synthesizes ALL findings/weaknesses/strengths into an editorial brief
 * 2. draft-refiner-v2: Refines the chapter based on the editorial brief
 *
 * Unlike run-refine-v2, this agent processes ALL available findings and weaknesses
 * without requiring manual selection. It's a "brute-force" approach for comprehensive
 * chapter refinement.
 *
 * @category writing.refinement.full
 * @type composite
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'run-refine-full-v2',
  kind: 'composite',
  name: 'Run Full Refine',
  description: 'Processes ALL available findings and weaknesses by synthesizing them into an editorial brief and refining the chapter accordingly. A brute-force approach for comprehensive refinement.',
  category: 'writing',
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata ---
  metadata: {
    status: 'active',
    type: 'composite',
    addedIn: '2026-01',
    lastUpdated: '2026-01',
    usedBy: [
      'use-run-refine-full.ts',
    ],
    // Composite agents specify which primitives they orchestrate
    composedOf: [
      'refine-synthesizer',
      'draft-refiner-v2',
    ],
    relatedAgents: ['refine-synthesizer', 'draft-refiner-v2', 'run-refine-v2'],
    taxonomyPath: 'writing.refinement.full',
  },
};
